import styled from "styled-components";

export const SOnboardingTemplatesModalImage = styled.img`
  border-radius: 8px;
  width: 100%;
  display: block;
`;
